<mat-card>
    <mat-card-content class="newOrder">
        <div class="titleHead">
            <div class="titleLeft">
                <title-back [addTitle]="true" [Title]="'KYC Docs'" (back)="closeDetails()"> </title-back>
                <mat-chip class="companyName" (click)="navigateTo(companyObj?.id)">{{companyObj?.legal_name}} <i
                        class="flaticon-open-tab"></i> </mat-chip>
            </div>
            <div class="chipHolder">

                <mat-chip [style.background-color]=" companyObj?.kyc_status?.color_code"
                    style="color:white">{{companyObj?.kyc_status?.name_kyc}}</mat-chip>
            </div>
        </div>
        <logzy-table-loader *ngIf="loading"></logzy-table-loader>
        <ng-container *ngIf="!loading">
            <div class="setTable">
                <ng-container *ngIf="companyKycDocs?.data.length">
                    <mat-table [dataSource]="companyKycDocs">

                        <ng-container matColumnDef="document_name">
                            <mat-header-cell *matHeaderCellDef> Document </mat-header-cell>
                            <mat-cell *matCellDef="let doc">
                                <span class="fullName">
                                    {{doc.tax_identifier?.name}}{{doc.tax_identifier?.is_identifier_required
                                    ? '*' : ''}}</span>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="id_value">
                            <mat-header-cell *matHeaderCellDef> ID </mat-header-cell>
                            <mat-cell *matCellDef="let doc">
                                {{doc.id_value ? doc.id_value : '-'}}
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="document">
                            <mat-header-cell *matHeaderCellDef> Uploads </mat-header-cell>
                            <mat-cell *matCellDef="let doc">
                                <ng-container *ngIf="doc.document!=null">
                                    <a [href]='doc.document.document_file' target="_blank"
                                        [download]="doc.document.original_filename+'.'+doc.document.extension">
                                        {{doc.document.original_filename}}.{{doc.document.extension}}</a>
                                </ng-container>
                                <ng-container *ngIf="doc.document==null">-</ng-container>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="remarks">
                            <mat-header-cell *matHeaderCellDef> Customer Remarks </mat-header-cell>
                            <mat-cell *matCellDef="let doc">
                                {{doc.remarks ? doc.remarks : '-'}}
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="status">
                            <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
                            <mat-cell *matCellDef="let doc">
                                <ng-container *ngIf="doc.status != null">
                                    <mat-chip [style.background-color]=" doc?.status?.color_code"
                                        style="color:white; width: fit-content;">{{doc.status.name}}</mat-chip>
                                </ng-container>
                                <ng-container *ngIf="doc.status == null">-</ng-container>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="admin_remarks">
                            <mat-header-cell *matHeaderCellDef> Approver Remarks </mat-header-cell>
                            <mat-cell *matCellDef="let doc, let i=index">
                                <div fxLayout="column">
                                    <app-text-field
                                        [isEditable]="!(doc.status.dev_name=='rejected' || doc.status.dev_name=='pending_for_reupload' || doc.status.dev_name=='approved' || doc.status.dev_name=='auto_approved')"
                                        [name]="'admin_remarks'+i" [(ngModel)]="doc.admin_remarks"
                                        [errors]="errorObj[i]?.admin_remarks"
                                        [disabled]="doc.status.dev_name=='approved' || doc.status.dev_name=='auto_approved'">
                                    </app-text-field>
                                    <span *ngIf="doc.approved_by != null" class="fs-10 ">
                                        by <b> {{doc.approved_by?.first_name}} {{doc.approved_by?.last_name}}</b>
                                        {{doc.approved_at | date:'dd MMM, yyyy'}}
                                    </span>
                                    <span *ngIf="doc.approved_by == null && doc.status.dev_name=='auto_approved'"
                                        class="fs-10 ">
                                        by System {{doc.approved_at | date:'dd MMM, yyyy'}}
                                    </span>
                                </div>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="actions">
                            <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
                            <mat-cell *matCellDef="let doc; let i=index">
                                <button mat-icon-button [matMenuTriggerFor]="menu"
                                    aria-label="Example icon-button with a menu"
                                    [disabled]="doc.document != null && (doc.status.dev_name=='approved' || doc.status.dev_name=='auto_approved')">
                                    <!-- <mat-icon>more_vert</mat-icon> -->
                                    <i class="flaticon-more"></i>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item (click)="addDocument(doc,i)">
                                        <span>Edit</span>
                                    </button>
                                    <ng-container
                                        *ngIf="!(doc.status.dev_name=='approved' || doc.status.dev_name=='auto_approved')">
                                        <button *ngIf="doc.status.dev_name!='pending_for_upload'" mat-menu-item
                                            (click)="kycDocVerification('approved',doc,i)">
                                            <span>Approve</span>
                                        </button>
                                        <ng-container
                                            *ngIf="doc.status.dev_name!='rejected' && doc.status.dev_name!='pending_for_upload'">
                                            <button mat-menu-item (click)="kycDocVerification('rejected',doc,i)">
                                                <span>Reject</span>
                                            </button>
                                        </ng-container>
                                        <ng-container *ngIf="doc.status.dev_name!='pending_for_reupload'">
                                            <button mat-menu-item
                                                (click)="kycDocVerification('pending_for_reupload',doc,i)">
                                                <span>Need more info</span>
                                            </button>
                                        </ng-container>
                                    </ng-container>
                                </mat-menu>
                            </mat-cell>
                        </ng-container>

                        <mat-header-row class="header-row" *matHeaderRowDef="displayColumns"></mat-header-row>
                        <mat-row *matRowDef="let row; let i = index; columns: displayColumns;"
                            [class.blur]="refreshDocList" [id]="'row-id-'+i"></mat-row>
                    </mat-table>

                    <div class="loadingData" [class.d-none]="!refreshDocList">
                        <logzy-gear-loader></logzy-gear-loader>
                    </div>

                    <!-- <mat-paginator [pageSizeOptions]="[5, 10, 25]" aria-label="Select page of users" [pageSize]="10"
                    [length]="customerPageLength" (page)="pageChanged($event)"></mat-paginator> -->
                </ng-container>
                <ng-container *ngIf="!companyKycDocs?.data.length">
                    <logzy-billu part1="No " part2="Data " part3="here." font="14px"></logzy-billu>
                </ng-container>
            </div>
            <span *ngIf="taxIdentifierList.length > 0" class="additionalDocs" id="additionalDoc">
                <span> <logzy-img-loader [src]="'/assets/images/icons/warning.svg'">
                    </logzy-img-loader> Document(s) pending for upload.</span>
                <div>
                    <ng-container *ngFor="let item of taxIdentifierList">
                        <mat-chip (click)="addDocument(item,null)">{{item.name}}{{item.is_identifier_required ? '*' :
                            ''}}</mat-chip>
                    </ng-container>
                </div>
            </span>
            <div class="kycContainer" *ngIf="companyKycDocModel != null">
                <div class="kycItem">
                    <div class=" kycBlock ">
                        <!-- Icon div -->
                        <div class="kycIcon">
                            <!-- <logzy-img-loader
                                [src]="'/assets/images/icons/file-type/'+companyKycDocModel.tax_identifier?.name+'.svg'">
                            </logzy-img-loader> -->
                            <app-file-field [showUploadedList]="false" [fileDropArea]="false" [isEditable]="false"
                                [cameraIcon]="true" [flatIconClass]="'upload-1'"
                                [(ngModel)]="companyKycDocModel.document" [cropper]="false"
                                [assetSource]="companyKycDocModel.tax_identifier?.icon_document?.document_file"
                                [multiple]="false"
                                [documentTypeDevName]="companyKycDocModel?.tax_identifier?.document_type?.dev_name"
                                [name]="'kycDoc'" fxLayout="column" [errors]="docErrorObj?.document">
                            </app-file-field>
                        </div>
                        <!-- Content div -->
                        <div class="kycDocs">
                            <div fxLayout="column">
                                <div class="kycHead">
                                    <span class="title">{{companyKycDocModel.tax_identifier?.document_name}} <span
                                            class="natureChip">{{companyKycDocModel.status?.name}}</span></span>
                                    <span class="note" *ngIf="companyKycDocModel.document==null"> <i
                                            class="flaticon-message"></i>
                                        Upload your
                                        {{companyKycDocModel.tax_identifier?.name}} </span>
                                    <span class="note" *ngIf="companyKycDocModel.document!=null"> <i
                                            class="flaticon-file"></i>
                                        {{companyKycDocModel.document.original_filename}}.{{companyKycDocModel.document.extension}}</span>
                                </div>
                                <ng-container *ngIf="companyKycDocModel.tax_identifier?.show_id_value_field">
                                    <app-text-field
                                        [isEditable]="!(companyKycDocModel.status?.dev_name=='auto_approved' || companyKycDocModel.status?.dev_name=='approved')"
                                        [name]="'taxIdentifier'" class="identifier" [placeholder]="'Identifier No.'"
                                        [(ngModel)]="companyKycDocModel.id_value" [errors]="docErrorObj?.id_value"
                                        [disabled]="companyKycDocModel.tax_identifier?.is_disabled">
                                    </app-text-field>
                                </ng-container>
                            </div>
                            <div fxLayout="row wrap" class=" gap-3 ">
                                <app-text-field [label]="'Customer Remarks'" [isEditable]="false" [name]="'remarks'"
                                    [placeholder]="'Remarks'" [(ngModel)]="companyKycDocModel.remarks"
                                    [errors]="docErrorObj?.remarks" fxFlex="12em">
                                </app-text-field>
                                <div fxFlex="12em" fxLayout="column" class="gap-3">
                                    <!-- <span>Upload Date: {{item.document?.created_at | date:'dd MMM, yyyy'}}</span> -->
                                    <span class="backBtn" (click)="hideOtherrows(null)"><i
                                            class="flaticon-back-arrow"></i> Back</span>
                                    <app-text-field [label]="'Approver Remarks'" [isEditable]="true"
                                        [name]="'admin_remarks'" [placeholder]="'Remarks'"
                                        [(ngModel)]="companyKycDocModel.admin_remarks"
                                        [errors]="docErrorObj?.admin_remarks">
                                    </app-text-field>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div fxLayout="column" class="justify-content-between align-items-end w-100 h-100">
                        <!-- <span class="uploadDate">Upload Date: {{companyKycDocModel.document?.created_at | date:'dd MMM, yyyy'}}</span> -->
                        <button mat-raised-button (click)="saveKYC(companyKycDocModel)"
                            class="Save sleekBtn">Save</button>
                    </div>
                </div>
            </div>
        </ng-container>
    </mat-card-content>
</mat-card>